import { render, staticRenderFns } from "./EtlStatusPage.vue?vue&type=template&id=76a73a2c"
import script from "./EtlStatusPage.vue?vue&type=script&lang=ts"
export * from "./EtlStatusPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports